import React from "react";

var ThumbsUpIcon = function ThumbsUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20 9h-7.625l1.472-3.889c.377-.996.042-2.135-.802-2.73-.964-.679-2.264-.427-2.937.569L6.019 9H6v9a4 4 0 0 0 4 4h6.7c.79 0 1.507-.466 1.828-1.188l3.3-7.425c.113-.255.172-.532.172-.812V11a2 2 0 0 0-2-2zM3 22a1 1 0 0 1-1-1V10a1 1 0 0 1 2 0v11a1 1 0 0 1-1 1z"
  }));
};

ThumbsUpIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
ThumbsUpIcon.defaultProps.solid = true;
export default ThumbsUpIcon;